import { Component } from '@angular/core';

@Component({
    selector: 'pp-account-setting-unlimited-info',
    templateUrl: './account-setting-unlimited-info.component.html',
    styleUrls: ['./account-setting-unlimited-info.component.scss'],
    standalone: false
})
export class AccountSettingUnlimitedInfoComponent {}
